import { AssemblyLayoutProps } from './AssemblyLayout.interface';
import { AssemblyLayoutContainer } from './AssemblyLayout.styled';

export const AssemblyLayout = (props: AssemblyLayoutProps) => {
  return (
    <AssemblyLayoutContainer
      $type={props?.type}
      $scale={props?.scale}
      data-testid="assembly-layout">
      {props.children}
    </AssemblyLayoutContainer>
  );
};
